export const AlertsTxt = {
  EVALUATE_FOR_EACH: "Evaluate for each (Optional)",
  DIMENSION: "Dimension",
  CREATE_NEW_ALLOCATION: "Create new allocation",
  NEED_ADVANCED_LOGIC: "Need advanced logic? ",
  VALUES_SELECTED: "values selected",
  DUPLICATE_SUCCESSFUL: "Alert was duplicated successfully",
  SUBSCRIPTION_UPDATED: "Subscription updated successfully",
};
